import CryptoJS from 'crypto-js';

const SECRET_KEY = 'ALLHANDSONDECK@2025';

// Helper to encode URL-safe Base64
const toUrlSafe = (str) => str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const fromUrlSafe = (str) => str.replace(/-/g, '+').replace(/_/g, '/');

export const encryptRef = (txRef) => {
  const encrypted = CryptoJS.AES.encrypt(txRef, SECRET_KEY).toString();
  return toUrlSafe(encrypted);
};

export const decryptRef = (encryptedRef) => {
  try {
    const base64 = fromUrlSafe(encryptedRef);
    const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error('Decryption failed:', err);
    return '';
  }
};
